import * as React from "react";

const AppTeatreSvgIcon = (props) => (
    <svg
      width={155}
      height={193.562}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g data-name="Group 2643">
        <path
          fill="#342f27"
          d="M8.935 7.654h140.424v140.424H8.935z"
          data-name="Rectangle 7003"
        />
        <path
          fill="#9a896e"
          d="M37.836 156.7 78.778 7.226 120.486 156.7Z"
          data-name="Path 4934"
          opacity={0.1}
        />
        <g data-name="Group 2639">
          <g fill="#221c14" data-name="Group 2641">
            <path
              d="m58.696 71.662 3.92-3.92 36.982 36.981-3.92 3.92z"
              data-name="Rectangle 7009"
            />
            <path
              d="M79.147 116.884a28.609 28.609 0 1 1 11.169-2.256 28.514 28.514 0 0 1-11.169 2.256Zm0-52.3a23.609 23.609 0 1 0 23.609 23.609 23.636 23.636 0 0 0-23.609-23.609Z"
              data-name="Path 5245"
            />
          </g>
        </g>
        <path
          fill="#615645"
          d="M37.836 156.7 149.049 7.226 120.486 156.7Z"
          data-name="Path 4936"
          opacity={0.23}
        />
        <path
          fill="#9a896e"
          d="M116.9 152.849 5.687 3.375l28.564 149.474Z"
          data-name="Path 5227"
          opacity={0.1}
        />
        <g data-name="Group 2635">
          <g data-name="Group 2045">
            <g data-name="Group 2044">
              <path
                fill="#19150f"
                d="M114.311 0c0 58.973 28.119 84.162 28.119 84.162v3.6s-16.312 25.989-16.312 66.97h25.323V0Z"
                data-name="Path 4937"
              />
            </g>
          </g>
          <g data-name="Group 2047">
            <g fill="#19150f" data-name="Group 2046">
              <path
                d="M39.508 0c0 58.973-28.118 84.162-28.118 84.162v3.6s16.312 25.989 16.312 66.97H2.379V0Z"
                data-name="Path 4938"
              />
              <path
                d="M2.271 84.162h9.477v3.946H2.271z"
                data-name="Rectangle 7005"
              />
            </g>
          </g>
          <path
            fill="#19150f"
            d="M62.158.161a19.452 19.452 0 0 0-.248 3.1c0 9.5 6.83 17.206 15.254 17.206s15.254-7.7 15.254-17.206a19.451 19.451 0 0 0-.251-3.1Z"
            data-name="Path 5053"
          />
          <path
            fill="#19150f"
            d="M91.302.161a19.451 19.451 0 0 0-.248 3.1c0 9.5 6.83 17.206 15.254 17.206s15.256-7.703 15.256-17.206a19.426 19.426 0 0 0-.248-3.1Z"
            data-name="Path 5054"
          />
          <path
            fill="#19150f"
            d="M120.679.161a19.483 19.483 0 0 0-.247 3.1c0 9.5 6.829 17.206 15.254 17.206s15.254-7.7 15.254-17.206a19.486 19.486 0 0 0-.247-3.1Z"
            data-name="Path 5055"
          />
          <path
            fill="#19150f"
            d="M32.904.161a19.48 19.48 0 0 0-.247 3.1c0 9.5 6.829 17.206 15.254 17.206s15.254-7.7 15.254-17.206a19.451 19.451 0 0 0-.247-3.1Z"
            data-name="Path 5056"
          />
          <path
            fill="#19150f"
            d="M3.515.161a19.481 19.481 0 0 0-.247 3.1c0 9.5 6.829 17.206 15.254 17.206s15.254-7.703 15.254-17.206a19.481 19.481 0 0 0-.25-3.1Z"
            data-name="Path 5057"
          />
        </g>
        <g data-name="Group 2642">
          <g data-name="Group 2063">
            <g data-name="Group 2062">
              <g data-name="Group 2048">
                <path
                  fill="#eaac2f"
                  d="M105.728 159.883a2.406 2.406 0 0 1-2.416 2.4h-9.721a2.406 2.406 0 0 1-2.416-2.4v-12.462a2.406 2.406 0 0 1 2.416-2.4h9.721a2.406 2.406 0 0 1 2.416 2.4Z"
                  data-name="Path 4939"
                />
                <path
                  fill="#221c14"
                  d="M103.318 146.073a22.357 22.357 0 0 1-4.892.811 32.246 32.246 0 0 1-4.835-.811 2.406 2.406 0 0 0-2.416 2.4v12.444a2.412 2.412 0 0 0 2.419 2.4h9.734a2.4 2.4 0 0 0 2.4-2.4v-12.448a2.4 2.4 0 0 0-2.41-2.396Z"
                  data-name="Path 4940"
                />
              </g>
              <g data-name="Group 2049">
                <path
                  fill="#eaac2f"
                  d="M89.7 159.883a2.406 2.406 0 0 1-2.415 2.4h-9.721a2.406 2.406 0 0 1-2.416-2.4v-12.462a2.406 2.406 0 0 1 2.416-2.4h9.721a2.406 2.406 0 0 1 2.415 2.4Z"
                  data-name="Path 4941"
                />
                <path
                  fill="#221c14"
                  d="M87.29 146.073a22.357 22.357 0 0 1-4.892.811 32.24 32.24 0 0 1-4.835-.811 2.406 2.406 0 0 0-2.416 2.4v12.444a2.412 2.412 0 0 0 2.419 2.4h9.729a2.4 2.4 0 0 0 2.4-2.4v-12.448a2.4 2.4 0 0 0-2.405-2.396Z"
                  data-name="Path 4942"
                />
              </g>
              <g data-name="Group 2050">
                <path
                  fill="#eaac2f"
                  d="M73.672 159.883a2.406 2.406 0 0 1-2.416 2.4h-9.721a2.406 2.406 0 0 1-2.416-2.4v-12.462a2.406 2.406 0 0 1 2.416-2.4h9.721a2.406 2.406 0 0 1 2.416 2.4Z"
                  data-name="Path 4943"
                />
                <path
                  fill="#221c14"
                  d="M71.262 146.073a22.361 22.361 0 0 1-4.892.811 32.235 32.235 0 0 1-4.835-.811 2.406 2.406 0 0 0-2.416 2.4v12.444a2.412 2.412 0 0 0 2.419 2.4h9.729a2.4 2.4 0 0 0 2.4-2.4v-12.448a2.4 2.4 0 0 0-2.405-2.396Z"
                  data-name="Path 4944"
                />
              </g>
              <g data-name="Group 2051">
                <path
                  fill="#eaac2f"
                  d="M57.978 159.883a2.406 2.406 0 0 1-2.416 2.4h-9.724a2.406 2.406 0 0 1-2.416-2.4v-12.462a2.406 2.406 0 0 1 2.416-2.4h9.721a2.406 2.406 0 0 1 2.416 2.4Z"
                  data-name="Path 4945"
                />
                <path
                  fill="#221c14"
                  d="M55.564 146.073a22.361 22.361 0 0 1-4.892.811 32.24 32.24 0 0 1-4.835-.811 2.406 2.406 0 0 0-2.416 2.4v12.444a2.412 2.412 0 0 0 2.419 2.4h9.729a2.4 2.4 0 0 0 2.4-2.4v-12.448a2.4 2.4 0 0 0-2.405-2.396Z"
                  data-name="Path 4946"
                />
              </g>
              <g data-name="Group 2052">
                <path
                  fill="#eaac2f"
                  d="M42.275 159.883a2.406 2.406 0 0 1-2.416 2.4h-9.721a2.406 2.406 0 0 1-2.415-2.4v-12.462a2.406 2.406 0 0 1 2.415-2.4h9.721a2.406 2.406 0 0 1 2.416 2.4Z"
                  data-name="Path 4947"
                />
                <path
                  fill="#221c14"
                  d="M39.865 146.073a22.358 22.358 0 0 1-4.892.811 32.25 32.25 0 0 1-4.835-.811 2.406 2.406 0 0 0-2.415 2.4v12.444a2.412 2.412 0 0 0 2.418 2.4h9.729a2.4 2.4 0 0 0 2.4-2.4v-12.448a2.4 2.4 0 0 0-2.405-2.396Z"
                  data-name="Path 4948"
                />
              </g>
              <g data-name="Group 2057">
                <path
                  fill="#eaac2f"
                  d="M121.776 159.883a2.406 2.406 0 0 1-2.416 2.4h-9.723a2.406 2.406 0 0 1-2.416-2.4v-12.462a2.406 2.406 0 0 1 2.416-2.4h9.721a2.406 2.406 0 0 1 2.416 2.4Z"
                  data-name="Path 4957"
                />
                <path
                  fill="#221c14"
                  d="M119.361 146.073a22.4 22.4 0 0 1-4.894.811 32.162 32.162 0 0 1-4.831-.811 2.4 2.4 0 0 0-2.411 2.4v12.444a2.4 2.4 0 0 0 2.408 2.4h9.729a2.408 2.408 0 0 0 2.415-2.4v-12.448a2.406 2.406 0 0 0-2.416-2.396Z"
                  data-name="Path 4958"
                />
              </g>
            </g>
          </g>
          <g data-name="Group 2076">
            <path
              fill="#221c14"
              d="M116.539 152.71v.024h.835v-.024h7.039c0-.461.058-1.5.058-2.023a1.738 1.738 0 0 0-1.134-1.55 21.837 21.837 0 0 0-2.321-.887l.048-.086-1.453-.382a7.907 7.907 0 0 1-.387-2.4 5.782 5.782 0 0 0 1.017-1.254 10.331 10.331 0 0 0 .248-1.337c1.14-.307 1.354-2.221.828-2.377a.481.481 0 0 0-.406.077 2.905 2.905 0 0 0 .23-1.37c-.051-1.155-.169-1.842-.709-1.992a2.5 2.5 0 0 0-1.384-1.691 4.754 4.754 0 0 0-3.983-.117 4.365 4.365 0 0 0-1.725 1.343 4.014 4.014 0 0 0-.2 3.762c.026.049.053.095.079.14a.549.549 0 0 0-.505-.15c-.46.134-.311 2.1.851 2.383a10.409 10.409 0 0 0 .248 1.332 5.192 5.192 0 0 0 .881 1.117 8.271 8.271 0 0 1-.392 2.537l-1.514.4.049.086a21.209 21.209 0 0 0-2.263.867 1.738 1.738 0 0 0-1.134 1.55c0 .522.058 1.457.058 2.023Z"
              data-name="Path 4967"
            />
            <path
              fill="#221c14"
              d="M17.297 153.311c0 .608.067 2.411.067 2.949h17.383c0-.536.067-2.329.067-2.943v-.006a1.634 1.634 0 0 0-.425-1.138 3.338 3.338 0 0 0-.9-.669c-.792-.436-4.1-1.578-4.114-1.583a10.438 10.438 0 0 1-.885-3.259l.045-.054-.007.009a3.031 3.031 0 0 0 1.469 2.347 3.76 3.76 0 0 0 4.494-.716 2.433 2.433 0 0 1-2.387-2.74c.048-1.935 1.425-11.555-5.891-10.562h-.43c-7.315-.993-5.947 8.627-5.891 10.562a2.577 2.577 0 0 1-2.387 2.74 3.76 3.76 0 0 0 4.493.716 3.008 3.008 0 0 0 1.466-2.315q.065.076.13.147a10.053 10.053 0 0 1-.864 3.125s-.391.135-.931.328l-.024.009-.022.007c-1.046.374-2.623.956-3.138 1.239a2.026 2.026 0 0 0-1.318 1.807Zm13.443-10.98a1.746 1.746 0 0 1-.216.495 3.041 3.041 0 0 0 .216-.495Zm-.958 1.923a10.334 10.334 0 0 0 .269-1.079 7.008 7.008 0 0 1-.269 1.078Zm1.081-2.984a.411.411 0 0 0-.017-.046.526.526 0 0 0-.069-.114.255.255 0 0 1 .088.159Zm-9.565 1.307.006.016-.005-.013Zm.114.235a1.573 1.573 0 0 1-.095-.191c.032.068.063.131.096.191Zm.473.365a.184.184 0 0 0 .03-.023c0 .008 0 .016.005.024Z"
              data-name="Path 4968"
            />
            <g data-name="Group 2075">
              <g data-name="Group 2064">
                <path
                  fill="#eaac2f"
                  d="M88.674 166.92a2.734 2.734 0 0 1-2.745 2.723H74.88a2.734 2.734 0 0 1-2.745-2.723v-14.163a2.735 2.735 0 0 1 2.745-2.724h11.048a2.735 2.735 0 0 1 2.745 2.724Z"
                  data-name="Path 4969"
                />
                <path
                  fill="#221c14"
                  d="M85.935 151.225a25.411 25.411 0 0 1-5.56.922 36.646 36.646 0 0 1-5.5-.922 2.735 2.735 0 0 0-2.745 2.724v14.147a2.741 2.741 0 0 0 2.749 2.728h11.058a2.727 2.727 0 0 0 2.732-2.728v-14.147a2.729 2.729 0 0 0-2.734-2.724Z"
                  data-name="Path 4970"
                />
              </g>
              <g data-name="Group 2065">
                <path
                  fill="#eaac2f"
                  d="M70.455 166.92a2.734 2.734 0 0 1-2.745 2.723H56.663a2.734 2.734 0 0 1-2.745-2.723v-14.163a2.735 2.735 0 0 1 2.745-2.724h11.048a2.734 2.734 0 0 1 2.744 2.724Z"
                  data-name="Path 4971"
                />
                <path
                  fill="#221c14"
                  d="M67.718 151.225a25.41 25.41 0 0 1-5.56.922 36.644 36.644 0 0 1-5.5-.922 2.735 2.735 0 0 0-2.745 2.724v14.147a2.741 2.741 0 0 0 2.749 2.728h11.063a2.727 2.727 0 0 0 2.73-2.728v-14.147a2.729 2.729 0 0 0-2.737-2.724Z"
                  data-name="Path 4972"
                />
              </g>
              <g data-name="Group 2066">
                <path
                  fill="#eaac2f"
                  d="M52.241 166.92a2.734 2.734 0 0 1-2.745 2.723H38.447a2.734 2.734 0 0 1-2.745-2.723v-14.163a2.734 2.734 0 0 1 2.745-2.724h11.048a2.735 2.735 0 0 1 2.745 2.724Z"
                  data-name="Path 4973"
                />
                <path
                  fill="#221c14"
                  d="M49.502 151.225a25.411 25.411 0 0 1-5.56.922 36.641 36.641 0 0 1-5.495-.922 2.735 2.735 0 0 0-2.745 2.724v14.147a2.741 2.741 0 0 0 2.749 2.728h11.062a2.727 2.727 0 0 0 2.732-2.728v-14.147a2.729 2.729 0 0 0-2.743-2.724Z"
                  data-name="Path 4974"
                />
              </g>
              <g data-name="Group 2067">
                <path
                  fill="#eaac2f"
                  d="M34.398 166.92a2.735 2.735 0 0 1-2.746 2.723H20.605a2.735 2.735 0 0 1-2.746-2.723v-14.163a2.735 2.735 0 0 1 2.746-2.724h11.048a2.735 2.735 0 0 1 2.746 2.724Z"
                  data-name="Path 4975"
                />
                <path
                  fill="#221c14"
                  d="M31.659 151.225a25.407 25.407 0 0 1-5.56.922 36.635 36.635 0 0 1-5.495-.922 2.735 2.735 0 0 0-2.746 2.724v14.147a2.741 2.741 0 0 0 2.749 2.728h11.059a2.727 2.727 0 0 0 2.732-2.728v-14.147a2.729 2.729 0 0 0-2.739-2.724Z"
                  data-name="Path 4976"
                />
              </g>
              <g data-name="Group 2070">
                <path
                  fill="#eaac2f"
                  d="M106.913 166.92a2.735 2.735 0 0 1-2.745 2.723H93.119a2.734 2.734 0 0 1-2.745-2.723v-14.163a2.735 2.735 0 0 1 2.745-2.724h11.052a2.735 2.735 0 0 1 2.745 2.724Z"
                  data-name="Path 4981"
                />
                <path
                  fill="#221c14"
                  d="M104.171 151.225a25.451 25.451 0 0 1-5.562.922 36.549 36.549 0 0 1-5.491-.922 2.731 2.731 0 0 0-2.741 2.724v14.147a2.731 2.731 0 0 0 2.737 2.728h11.057a2.737 2.737 0 0 0 2.745-2.728v-14.147a2.734 2.734 0 0 0-2.745-2.724Z"
                  data-name="Path 4982"
                />
              </g>
              <g data-name="Group 2071">
                <path
                  fill="#eaac2f"
                  d="M125.208 166.92a2.734 2.734 0 0 1-2.745 2.723h-11.048a2.735 2.735 0 0 1-2.746-2.723v-14.163a2.735 2.735 0 0 1 2.746-2.724h11.051a2.734 2.734 0 0 1 2.745 2.724Z"
                  data-name="Path 4983"
                />
                <path
                  fill="#221c14"
                  d="M122.48 151.225a25.339 25.339 0 0 1-5.554.922 36.811 36.811 0 0 1-5.5-.922 2.742 2.742 0 0 0-2.753 2.724v14.147a2.759 2.759 0 0 0 2.77 2.728h11.058a2.709 2.709 0 0 0 2.711-2.728v-14.147a2.72 2.72 0 0 0-2.732-2.724Z"
                  data-name="Path 4984"
                />
              </g>
              <g data-name="Group 2072">
                <path
                  fill="#eaac2f"
                  d="M143.446 166.92a2.734 2.734 0 0 1-2.745 2.723h-11.049a2.734 2.734 0 0 1-2.745-2.723v-14.163a2.735 2.735 0 0 1 2.745-2.724H140.7a2.734 2.734 0 0 1 2.745 2.724Z"
                  data-name="Path 4985"
                />
                <path
                  fill="#221c14"
                  d="M140.699 151.225a25.469 25.469 0 0 1-5.564.922 36.52 36.52 0 0 1-5.489-.922 2.729 2.729 0 0 0-2.739 2.724v14.147a2.727 2.727 0 0 0 2.733 2.728h11.058a2.741 2.741 0 0 0 2.749-2.728v-14.147a2.736 2.736 0 0 0-2.748-2.724Z"
                  data-name="Path 4986"
                />
              </g>
            </g>
          </g>
          <g data-name="Group 2089">
            <g data-name="Group 2088">
              <g data-name="Group 2077">
                <path
                  fill="#eaac2f"
                  d="M87.4 176.596a3.375 3.375 0 0 1-3.388 3.361H70.376a3.375 3.375 0 0 1-3.388-3.361v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.388 3.361Z"
                  data-name="Path 4991"
                />
                <path
                  fill="#221c14"
                  d="M84.02 157.225a31.364 31.364 0 0 1-6.862 1.138 45.229 45.229 0 0 1-6.782-1.138 3.375 3.375 0 0 0-3.388 3.361v17.461a3.383 3.383 0 0 0 3.392 3.367h13.648a3.366 3.366 0 0 0 3.373-3.367v-17.461a3.368 3.368 0 0 0-3.381-3.361Z"
                  data-name="Path 4992"
                />
              </g>
              <g data-name="Group 2078">
                <path
                  fill="#eaac2f"
                  d="M64.917 176.596a3.375 3.375 0 0 1-3.388 3.361H47.892a3.375 3.375 0 0 1-3.388-3.361v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.388 3.361Z"
                  data-name="Path 4993"
                />
                <path
                  fill="#221c14"
                  d="M61.536 157.225a31.367 31.367 0 0 1-6.862 1.138 45.229 45.229 0 0 1-6.783-1.138 3.375 3.375 0 0 0-3.388 3.361v17.461a3.383 3.383 0 0 0 3.393 3.367h13.647a3.366 3.366 0 0 0 3.372-3.367v-17.461a3.368 3.368 0 0 0-3.379-3.361Z"
                  data-name="Path 4994"
                />
              </g>
              <g data-name="Group 2079">
                <path
                  fill="#eaac2f"
                  d="M42.434 176.596a3.375 3.375 0 0 1-3.389 3.361H25.412a3.375 3.375 0 0 1-3.389-3.361v-17.481a3.375 3.375 0 0 1 3.389-3.361h13.636a3.375 3.375 0 0 1 3.389 3.361Z"
                  data-name="Path 4995"
                />
                <path
                  fill="#221c14"
                  d="M39.053 157.225a31.364 31.364 0 0 1-6.862 1.138 45.231 45.231 0 0 1-6.779-1.138 3.375 3.375 0 0 0-3.389 3.361v17.461a3.383 3.383 0 0 0 3.389 3.367H39.06a3.366 3.366 0 0 0 3.373-3.367v-17.461a3.369 3.369 0 0 0-3.38-3.361Z"
                  data-name="Path 4996"
                />
              </g>
              <g data-name="Group 2080">
                <path
                  fill="#eaac2f"
                  d="M20.411 176.596a3.375 3.375 0 0 1-3.388 3.361H3.388A3.375 3.375 0 0 1 0 176.596v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.388 3.361Z"
                  data-name="Path 4997"
                />
                <path
                  fill="#221c14"
                  d="M17.032 157.225a31.364 31.364 0 0 1-6.862 1.138 45.224 45.224 0 0 1-6.782-1.138A3.375 3.375 0 0 0 0 160.586v17.461a3.383 3.383 0 0 0 3.392 3.367H17.04a3.366 3.366 0 0 0 3.372-3.367v-17.461a3.368 3.368 0 0 0-3.38-3.361Z"
                  data-name="Path 4998"
                />
              </g>
              <g data-name="Group 2083">
                <path
                  fill="#eaac2f"
                  d="M109.911 176.596a3.375 3.375 0 0 1-3.388 3.361H92.886a3.375 3.375 0 0 1-3.388-3.361v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.388 3.361Z"
                  data-name="Path 5003"
                />
                <path
                  fill="#221c14"
                  d="M106.523 157.225a31.418 31.418 0 0 1-6.865 1.138 45.12 45.12 0 0 1-6.777-1.138 3.37 3.37 0 0 0-3.383 3.361v17.461a3.37 3.37 0 0 0 3.378 3.367h13.647a3.378 3.378 0 0 0 3.387-3.367v-17.461a3.375 3.375 0 0 0-3.387-3.361Z"
                  data-name="Path 5004"
                />
              </g>
              <g data-name="Group 2084">
                <path
                  fill="#eaac2f"
                  d="M132.49 176.596a3.375 3.375 0 0 1-3.389 3.361h-13.636a3.375 3.375 0 0 1-3.388-3.361v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.389 3.361Z"
                  data-name="Path 5005"
                />
                <path
                  fill="#221c14"
                  d="M129.122 157.225a31.273 31.273 0 0 1-6.855 1.138 45.423 45.423 0 0 1-6.793-1.138 3.383 3.383 0 0 0-3.4 3.361v17.461a3.406 3.406 0 0 0 3.419 3.367h13.648a3.344 3.344 0 0 0 3.347-3.367v-17.461a3.357 3.357 0 0 0-3.366-3.361Z"
                  data-name="Path 5006"
                />
              </g>
              <g data-name="Group 2085">
                <path
                  fill="#eaac2f"
                  d="M155 176.596a3.375 3.375 0 0 1-3.388 3.361h-13.637a3.375 3.375 0 0 1-3.388-3.361v-17.481a3.375 3.375 0 0 1 3.388-3.361h13.636a3.375 3.375 0 0 1 3.388 3.361Z"
                  data-name="Path 5007"
                />
                <path
                  fill="#221c14"
                  d="M151.609 157.225a31.435 31.435 0 0 1-6.867 1.138 45.076 45.076 0 0 1-6.774-1.138 3.369 3.369 0 0 0-3.381 3.361v17.461a3.366 3.366 0 0 0 3.373 3.367h13.648a3.383 3.383 0 0 0 3.393-3.367v-17.461a3.377 3.377 0 0 0-3.392-3.361Z"
                  data-name="Path 5008"
                />
              </g>
            </g>
          </g>
          <g data-name="Group 2099">
            <path
              fill="#221c14"
              d="M74.589 164.72c-.438-1.793-2.518-3.46-3.694-5.606-1.3-2.369-1.09-6.74-1.038-7.553a3.818 3.818 0 0 0 .473-2.2c.053-1.805-.128-9.588-7.226-9.3.014 0-7.95-.824-7.419 9.525a4.276 4.276 0 0 0 .441 1.836s.406 5.067-1.029 7.686c-1.22 2.227-3.415 3.938-3.737 5.81a2.893 2.893 0 0 0-1.668 2.565c0 .935.1 2.085.1 2.911h26.707c0-1.015.1-1.976.1-2.911.007-1.333-.799-2.093-2.01-2.763Zm-17.735-12.516a.212.212 0 0 1-.032 0 .211.211 0 0 0 .031 0Zm-.077 0h-.011Zm-.036-.008-.032-.012Zm-.35-.31.026.034-.005-.006Zm.058.076.019.022-.018-.021Zm.107.116.008.008Zm1.636 3.66.006.013v-.007Zm.468.777.032.048-.03-.044Zm.222.316Zm10.74-4.9Zm-.131.146-.026.024Zm-.054.046Zm-1.709 3.913.012-.021-.011.02Zm.585-1.176.03-.069Zm.857-2.667.024.006-.023-.006Zm.077.01Zm.065-.012h.016Zm.031-.012.035-.018-.034.017Zm.37-.377Zm-13.437-.1.02.032Zm-.055-.1.018.033v-.005Zm13.566.072Zm-13.617-.17v-.008l.015.03Z"
              data-name="Path 5013"
            />
            <path
              fill="#221c14"
              d="M90.954 171.434h13.266c0-1.009.1-1.964.1-2.892 0-1.335-.807-2.09-2.018-2.758a24.708 24.708 0 0 0-2.442-1.029 11.486 11.486 0 0 0-2.471-.907c-.794-.283-1.359-.478-1.367-.481-.681-1.1-.889-3.434-.945-5.194a7.528 7.528 0 0 0 1.218-1.6 17.847 17.847 0 0 0 .424-2.285c1.993-.489 2.249-3.859 1.46-4.088a.718.718 0 0 0-.08-.018.4.4 0 0 1 .08.018s1.041-4.918-1.473-5.945a4.706 4.706 0 0 0-1.886-3.815 20.324 20.324 0 0 1-3.466-2.758 3.473 3.473 0 0 0 .741 1.373 2.891 2.891 0 0 1-2.112-1.581 1.247 1.247 0 0 0 .381 1.755 1.325 1.325 0 0 1-1.134-.62s-.3 1.082 1.19 1.372c0 0-1.8.1-1.634-1.452a10.361 10.361 0 0 0-2.6 2.809 6.975 6.975 0 0 1 .684-1.339 4.631 4.631 0 0 0-1.664 2.7 12.712 12.712 0 0 0-1.368 3.5 9.578 9.578 0 0 0-.234 3.972.721.721 0 0 0-.181.029c-.9.266-.534 3.55 1.421 4.076a17.954 17.954 0 0 0 .425 2.293 9.081 9.081 0 0 0 1.54 1.943c-.072 1.71-.3 3.821-.932 4.853l-1.367.481a11.469 11.469 0 0 0-2.472.907 24.729 24.729 0 0 0-2.442 1.028c-1.211.668-2.018 1.423-2.018 2.758 0 .928.1 2.072.1 2.892h13.266Z"
              data-name="Path 5014"
            />
            <g data-name="Group 2098">
              <g data-name="Group 2090">
                <path
                  fill="#eaac2f"
                  d="M47.882 187.656a4.137 4.137 0 0 1-4.154 4.12H27.012a4.137 4.137 0 0 1-4.154-4.12v-21.429a4.137 4.137 0 0 1 4.154-4.121h16.716a4.138 4.138 0 0 1 4.154 4.121Z"
                  data-name="Path 5015"
                />
                <path
                  fill="#221c14"
                  d="M43.738 163.909a38.458 38.458 0 0 1-8.412 1.4 55.449 55.449 0 0 1-8.314-1.4 4.137 4.137 0 0 0-4.15 4.121v21.4a4.148 4.148 0 0 0 4.159 4.128h16.731a4.126 4.126 0 0 0 4.134-4.128v-21.4a4.129 4.129 0 0 0-4.148-4.121Z"
                  data-name="Path 5016"
                />
              </g>
              <g data-name="Group 2093">
                <path
                  fill="#eaac2f"
                  d="M75.477 187.656a4.137 4.137 0 0 1-4.154 4.12H54.607a4.137 4.137 0 0 1-4.154-4.12v-21.429a4.137 4.137 0 0 1 4.154-4.121h16.715a4.137 4.137 0 0 1 4.154 4.121Z"
                  data-name="Path 5021"
                />
                <path
                  fill="#221c14"
                  d="M71.322 163.909a38.52 38.52 0 0 1-8.416 1.4 55.316 55.316 0 0 1-8.307-1.4 4.132 4.132 0 0 0-4.147 4.121v21.4a4.132 4.132 0 0 0 4.141 4.128h16.729a4.142 4.142 0 0 0 4.152-4.128v-21.4a4.136 4.136 0 0 0-4.152-4.121Z"
                  data-name="Path 5022"
                />
              </g>
              <g data-name="Group 2094">
                <path
                  fill="#eaac2f"
                  d="M103.157 187.656a4.137 4.137 0 0 1-4.154 4.12H82.287a4.137 4.137 0 0 1-4.154-4.12v-21.429a4.137 4.137 0 0 1 4.154-4.121h16.716a4.137 4.137 0 0 1 4.154 4.121Z"
                  data-name="Path 5023"
                />
                <path
                  fill="#221c14"
                  d="M99.029 163.909a38.339 38.339 0 0 1-8.4 1.4 55.692 55.692 0 0 1-8.326-1.4 4.148 4.148 0 0 0-4.166 4.121v21.4a4.175 4.175 0 0 0 4.191 4.128h16.731a4.1 4.1 0 0 0 4.1-4.128v-21.4a4.115 4.115 0 0 0-4.13-4.121Z"
                  data-name="Path 5024"
                />
              </g>
              <g data-name="Group 2095">
                <path
                  fill="#eaac2f"
                  d="M130.752 187.656a4.137 4.137 0 0 1-4.154 4.12h-16.716a4.137 4.137 0 0 1-4.154-4.12v-21.429a4.138 4.138 0 0 1 4.154-4.121h16.716a4.137 4.137 0 0 1 4.154 4.121Z"
                  data-name="Path 5025"
                />
                <path
                  fill="#221c14"
                  d="M126.595 163.909a38.54 38.54 0 0 1-8.418 1.4 55.262 55.262 0 0 1-8.3-1.4 4.13 4.13 0 0 0-4.145 4.121v21.4a4.126 4.126 0 0 0 4.134 4.128h16.73a4.147 4.147 0 0 0 4.159-4.128v-21.4a4.14 4.14 0 0 0-4.16-4.121Z"
                  data-name="Path 5026"
                />
              </g>
            </g>
          </g>
        </g>
        <g fill="#221c14" data-name="Group 2636">
          <path
            d="m58.37 28.111 1.318-2.39 1.318 2.39 2.41 1.307-2.41 1.307-1.318 2.39-1.318-2.39-2.41-1.307Z"
            data-name="Path 5058"
          />
          <path
            d="m68.558 45.081 1.4-2.534 1.4 2.534 2.554 1.386-2.554 1.386-1.4 2.534-1.4-2.534-2.554-1.386Z"
            data-name="Path 5059"
          />
          <path
            d="m81.672 37.502 1-1.818 1 1.818 1.832.994-1.832.994-1 1.818-1-1.818-1.833-.994Z"
            data-name="Path 5061"
          />
          <path
            d="m97.745 28.647 1-1.818 1 1.818 1.832.994-1.832.994-1 1.818-1-1.818-1.833-.994Z"
            data-name="Path 5062"
          />
          <path
            d="m104.44 54.553 1-1.818 1 1.818 1.832.994-1.832.994-1 1.818-1-1.818-1.833-.994Z"
            data-name="Path 5063"
          />
          <path
            d="m44.401 60.086 1-1.818 1 1.818 1.832.994-1.832.994-1 1.818-1-1.818-1.833-.994Z"
            data-name="Path 5064"
          />
        </g>
      </g>
    </svg>
  );

export default AppTeatreSvgIcon